import {
  takeLatest,
  take,
  fork,
  all,
  call,
  select,
  put,
} from 'redux-saga/effects'

import {
  buildUrl,
} from 'helpers/actionHelper'
import T from 'i18n-react'
import { success, error } from 'containers/App/Notification/actions'

import {
  getRequest,
  postRequest,
} from 'helpers/RequestUtil'

import {
  FETCH_SPECIFICATIONS,
  POST_SPECIFICATIONS,
  IMPORT_SPECIFICATION,
  IMPORT_SPECIFICATIONS_SUMMARY,
} from './constants'
import {
  latestRevisionNumberSelector,
  allSpecsSelector,
  currRevisionNumberSelector
} from './selectors'
import {
  updateSpecifications,
  updateSelectedRevision,
  updateSpecSources,
  updateEditValue,
  updateImportSkusList,
  hideSpecificationsTable,
  fetchSpecificationsStart,
  fetchSpecificationsSuccess,
  fetchSpecificationsError,
  startFetchSpecificationsAsync,
  postSpecificationsStart,
  postSpecificationsSuccess,
  postSpecificationsError,
  importSpecificationsSummaryStart,
  importSpecificationsSummarySuccess,
  importSpecificationsSummaryError,
  importSpecificationStart,
  importSpecificationSuccess,
  importSpecificationError
} from './actions'


function* postSpecificationsHandler(id, productSpecs) {
  try {
    yield put(postSpecificationsStart())
    productSpecs = JSON.stringify(productSpecs)
    const data = yield call(
      postRequest,
      'specifications',
      {
        productSpecs
      },
      `/api/fulcrum/products/${id}/specifications`
    )
    yield put(success(T.translate('pages.admin.products.notification.modify_success')))
    yield put(postSpecificationsSuccess())
    return data
  } catch(error) {
    yield put(postSpecificationsError(error))
  }
}

function* fetchSpecifications(url) {
  try {
    yield put(startFetchSpecificationsAsync())
    yield put(fetchSpecificationsStart())
    const data = yield call(
      getRequest,
      url
    )
    yield put(fetchSpecificationsSuccess())
    return data
  } catch(error) {
    yield put(fetchSpecificationsError(error))
  }
}

function* fetchSpecificationsSummary(url) {
  try {
    yield put(importSpecificationsSummaryStart())
    const { data: { skus }} = yield call(
      getRequest,
      url
    )
    yield put(importSpecificationsSummarySuccess())
    yield put(updateImportSkusList(skus))
    return skus
  } catch(error) {
    yield put(importSpecificationsSummaryError(error))
  }
}

function* importSpecification(url) {
  try {
    yield put(importSpecificationStart())
    const { data: { specRevisions }} = yield call(
      getRequest,
      url
    )
    const latestRevision = Math.max(...Object.keys(specRevisions))
    const currRevision = yield select(currRevisionNumberSelector)
    let allSpecs = yield select(allSpecsSelector)
    allSpecs.data.specRevisions[currRevision]['data'] = specRevisions[latestRevision]['data']
    yield put(updateSpecifications(allSpecs))
    yield put(importSpecificationSuccess())

  } catch(error) {
    yield put(importSpecificationError(error))
  }
}

function* handlePostSpecifications(action) {
  const { id, specs } = action
  const data = yield call(postSpecificationsHandler, id, specs)
  if (data) {
    yield put(updateEditValue(false))
    yield put(updateSpecifications(data))
    const latestRevision = yield select(latestRevisionNumberSelector)
    yield put(updateSelectedRevision(latestRevision))
  } else {
    console.log('error')
  }
}

function* handleFetchSpecifications(action) {
  const { id } = action
  const url = buildUrl(`/api/fulcrum/products/${id}/specifications`)
  const data = yield call(fetchSpecifications, url)
  const numRevisions = Object.keys(data.data.specRevisions).length
  if (data && numRevisions > 0) {
    // specifications exist for this product, display them on the UI
    yield put(updateSpecifications(data))
    yield put(updateSelectedRevision(numRevisions))
    yield put(updateSpecSources(data)) 
    yield put(hideSpecificationsTable(false))
  } else {
    // no specifications exist for this product, so we can hide the product specification view
    yield put(hideSpecificationsTable(true))
  }
}

function* handleImportSpecificationsSummary(action) {
  const { id } = action
  const url = buildUrl(`/api/fulcrum/products/${id}/import_specifications_summary`)
  yield call(fetchSpecificationsSummary, url)
}

function* handleImportSpecification(action) {
  const { id } = action
  const url = buildUrl(`/api/fulcrum/products/${id}/specifications`)
  yield call(importSpecification, url)
}

function* watchPostSpecifications() {
  yield takeLatest(POST_SPECIFICATIONS, handlePostSpecifications)
}

function* watchFetchSpecifications() {
  yield takeLatest(FETCH_SPECIFICATIONS, handleFetchSpecifications)
}

function* watchImportSpecificationsSummary() {
  yield takeLatest(IMPORT_SPECIFICATIONS_SUMMARY, handleImportSpecificationsSummary)
}

function* watchImportSpecification() {
  yield takeLatest(IMPORT_SPECIFICATION, handleImportSpecification)
}

function* loadSagas() {
  yield all([
    fork(watchFetchSpecifications),
    fork(watchPostSpecifications),
    fork(watchImportSpecificationsSummary),
    fork(watchImportSpecification),
  ])
}

export default loadSagas
